import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import zhCN from 'ant-design-vue/es/locale/zh_CN'
import {printWelcome} from "@/lib/util";
import dayjs from "dayjs";
import 'dayjs/locale/zh-cn'
import {theme} from "ant-design-vue";
import {watchEffect} from "vue";
import {GlobalToken} from "ant-design-vue/es/theme";
import app from "@/model/app";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

dayjs.locale('zh-cn')
printWelcome()

/**
 * 驼峰转中划线函数
 * colorPrimary -> color-primary
 */
const toKebabCase = (str: string): string => {
  return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
};


// 静态配置：不需要单位的属性
const UNITLESS_KEYS = new Set(['zIndex', 'opacity', 'fontWeight', 'lineHeight', 'flex', 'order', 'flexGrow', 'flexShrink']);

/**
 * 更新 CSS 变量到独立的 Style 标签
 */
const updateCSSVariables = (tokens: GlobalToken, isDark: boolean) => {
  const STYLE_ID = 'css-variables';
  let styleElement = document.getElementById(STYLE_ID) as HTMLStyleElement;

  if (!styleElement) {
    styleElement = document.createElement('style');
    styleElement.id = STYLE_ID;
    document.head.appendChild(styleElement);
  }

  const cssRules: string[] = [];

  // 1. 处理 Ant Design Tokens
  Object.entries(tokens).forEach(([key, value]) => {
    if (typeof value !== 'string' && typeof value !== 'number') return;

    const cssVarName = `--ant-${toKebabCase(key)}`;
    let cssValue = value;

    // 数值单位处理：判断 Key 是否包含不带单位的关键词
    const needsUnit = typeof value === 'number' &&
        ![...UNITLESS_KEYS].some(unitless => key.toLowerCase().includes(unitless.toLowerCase()));

    if (needsUnit) {
      cssValue = `${value}px`;
    }

    cssRules.push(`${cssVarName}: ${cssValue};`);
  });

  // 2. 处理自定义业务变量
  const extraVars = {
    '--color-bg-secondary': isDark ? '#1c1c1c' : '#e2e6f3',
    '--color-editor-bg': isDark ? '#191919' : '#f5f5f5',
    '--color-bg-hover': isDark ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.06)',
    '--shadow-layout': isDark
        ? '0 5px 20px 0 rgba(0, 0, 0, 0.38)'
        : '0 5px 20px 0 rgba(32, 35, 87, .09)'
  };

  Object.entries(extraVars).forEach(([key, val]) => {
    cssRules.push(`${key}: ${val};`);
  });

  // 3. 一次性写入样式表
  styleElement.textContent = `:root {\n  ${cssRules.join('\n  ')}\n}`;
};


// 获取当前的 Token (包含 a-config-provider 注入的自定义配置)
const {token} = theme.useToken();
token.value.controlInteractiveSize = 20

// 监听 Token 变化（如中英文切换、暗黑模式切换、主题色更改）
watchEffect(() => {
  if (token.value) {
    updateCSSVariables(token.value, app.active.theme.dark);
  }
});


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_config_provider, {
      locale: _unref(zhCN),
      theme: {algorithm: _unref(app).active.theme.dark ? _unref(theme).darkAlgorithm : _unref(theme).defaultAlgorithm}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    }, 8, ["locale", "theme"]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { id: "captcha" }, null, -1))
  ], 64))
}
}

})